import { createSlice } from '@reduxjs/toolkit';

export const drawerSlice = createSlice({
  name: 'drawer',
  initialState: {
    drawerVisibility: false,
    drawerType: '',
    drawerProps: {},
  },
  reducers: {
    showDrawer: (state, action) => {
      state.drawerVisibility = true;
      state.drawerType = action.payload.drawerType;
      state.drawerProps = action.payload.drawerProps;
    },
    hideDrawer: (state) => {
      state.drawerVisibility = false;
    },
  },
});

export const { showDrawer, hideDrawer } = drawerSlice.actions;

export default drawerSlice.reducer;
